import { ownerScopeId } from './portfolioScope';

export const SCOPE_PARAM = 'escopo';

export const LEGACY_OWNER_PARAM = 'titular';

export const readScopeParam = (params: URLSearchParams): string[] => {
  const scope = params.getAll(SCOPE_PARAM).filter(Boolean);
  if (scope.length > 0) return scope;
  const legacyOwner = params.get(LEGACY_OWNER_PARAM);
  return legacyOwner ? [ownerScopeId(legacyOwner)] : [];
};
